(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/eurojackpot/components/play/assets/javascripts/views/system-rows-container.js') >= 0) return;  svs.modules.push('/modules/eurojackpot/components/play/assets/javascripts/views/system-rows-container.js');

'use strict';

svs.eurojackpot.components.play.views.SystemRowsContainer = Marionette.View.extend({
  className: 'numbergames-play-content grid-row padding-xs-h-1 padding-xs-bottom-2 padding-sm-h-1 padding-md-bottom-0 padding-md-h-2',
  regions: {
    boardContainerRegion: '#boardContainerRegion',
    systemSummaryRegion: '#systemSummaryRegion'
  },
  template(data) {
    return svs.eurojackpot.components.play.templates.system_rows_container(data);
  },
  onRender() {
    this.showChildView('boardContainerRegion', new svs.numbergames.game.views.BoardContainer({
      model: this.model,
      boardButtonsView: svs.numbergames.game.views.BoardButtonsSystem,
      className: 'board-container-eurojackpot'
    }));
    this.showChildView('systemSummaryRegion', new svs.numbergames.game.views.SystemSummary({
      model: this.model,
      ballRowSize: svs.core.detect.breakpoint.greaterThan('xs') ? 300 : 200,
      ballRowType: svs.tur.ball.row.Eurojackpot,
      className: 'number-games-system-summary-eurojackpot'
    }));
  }
});

 })(window);